export const DEFAULT_QUOTATION_HOURLY_RATE = 300;
export const DEFAULT_QUOTATION_INSPECTION_FEE = 600;
